module.exports = __webpack_public_path__ + "img/ali-clould.e1fa703a.svg";